export default "__VITE_ASSET__0eb68be8__"